"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormattedNumber = exports.FormattedMessage = exports.FormattedDate = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _reactIntl = require("react-intl");
var _excluded = ["FormattedComponent", "store"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var FormattedBase = (0, _mobxReact.inject)('store')((0, _mobxReact.observer)(function (props) {
  var FormattedComponent = props.FormattedComponent,
    store = props.store,
    newProps = _objectWithoutProperties(props, _excluded);
  if (store.platform.currentLanguage) {
    return /*#__PURE__*/_react["default"].createElement(FormattedComponent, newProps);
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, props.defaultMessage);
}));
var FormattedMessage = exports.FormattedMessage = function FormattedMessage(props) {
  return /*#__PURE__*/_react["default"].createElement(FormattedBase, _extends({
    FormattedComponent: _reactIntl.FormattedMessage
  }, props));
};
var FormattedNumber = exports.FormattedNumber = function FormattedNumber(props) {
  return /*#__PURE__*/_react["default"].createElement(FormattedBase, _extends({
    FormattedComponent: _reactIntl.FormattedNumber
  }, props));
};
var FormattedDate = exports.FormattedDate = function FormattedDate(props) {
  return /*#__PURE__*/_react["default"].createElement(FormattedBase, _extends({
    FormattedComponent: _reactIntl.FormattedDate
  }, props));
};
//# sourceMappingURL=index.js.map